interface FilterOption {
  value: string;
  label: string;
}

interface FilterRowProps {
  title: string;
  options: FilterOption[];
  selected: string[];
  onToggle: (value: string) => void;
  onClear?: () => void;
}

function FilterRow({ title, options, selected, onToggle, onClear }: FilterRowProps) {
  return (
    <div className="flex flex-col gap-2.5 border-b border-background-800 py-4 last:border-b-0 md:flex-row md:items-start md:gap-5 md:py-3.5">
      <div className="flex shrink-0 items-center justify-between md:w-24 md:justify-start">
        <span className="text-sm font-medium text-foreground-300">{title}</span>
        {onClear && (
          <button
            type="button"
            onClick={onClear}
            className="text-xs text-foreground-500 hover:text-primary-400 md:hidden"
          >
            重置
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = selected.includes(opt.value);
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onToggle(opt.value)}
              className={`min-h-8 whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                active
                  ? 'bg-primary-500 font-medium text-background-950'
                  : 'bg-background-800 text-foreground-300 hover:bg-background-700 hover:text-foreground-50'
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

interface FilterPanelProps {
  genres: string[];
  years: number[];
  regions: string[];
  selectedGenres: string[];
  selectedYears: string[];
  selectedRegions: string[];
  onToggleGenre: (v: string) => void;
  onToggleYear: (v: string) => void;
  onToggleRegion: (v: string) => void;
  onClearAll: () => void;
}

export default function FilterPanel({
  genres,
  years,
  regions,
  selectedGenres,
  selectedYears,
  selectedRegions,
  onToggleGenre,
  onToggleYear,
  onToggleRegion,
  onClearAll,
}: FilterPanelProps) {
  const hasFilter =
    selectedGenres.length > 0 || selectedYears.length > 0 || selectedRegions.length > 0;

  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-100">
          <i className="ri-filter-3-line text-primary-400" />
          筛选条件
        </h3>
        {hasFilter && (
          <button
            type="button"
            onClick={onClearAll}
            className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-400 transition-colors hover:text-primary-400"
          >
            <i className="ri-refresh-line" />
            重置筛选
          </button>
        )}
      </div>
      <FilterRow
        title="类型 / 题材"
        options={genres.map((g) => ({ value: g, label: g }))}
        selected={selectedGenres}
        onToggle={onToggleGenre}
        onClear={onClearAll}
      />
      <FilterRow
        title="年份"
        options={years.map((y) => ({ value: String(y), label: `${y}年` }))}
        selected={selectedYears}
        onToggle={onToggleYear}
        onClear={onClearAll}
      />
      <FilterRow
        title="地区"
        options={regions.map((r) => ({ value: r, label: r }))}
        selected={selectedRegions}
        onToggle={onToggleRegion}
        onClear={onClearAll}
      />
    </div>
  );
}